export const AdyenTranslation = {
  'de-DE': {
    'creditCard.numberField.title': 'Kreditkartennummer',
    'creditCard.numberField.invalid': 'Ungültige Kreditkartennummer',
    'creditCard.expiryDateField.invalid': 'Ungültiges Ablaufdatum',
  },
};
